export default __webpack_public_path__ + "static/media/erx-delivery-rejected-icon.09b5014f.svg";